const ManifestKeys = {
  TITLE: "title",
  ACTIVITYLOG_TITLE: "activityLog",
  SCAC: "carrierCode",
  TRIP_NUM: "tripNum",
  DRIVER: "driver",
  EXP_ARRIVAL_DATE: "expArrivalDate",
  EXP_ARRIVAL_DATE_ONLY: "expArrivalDateOnly",
  EXP_ARRIVAL_TIME: "expArrivalTime",
  FIRST_EXPECTED_PORT: "firstExpectedPort",
  CARGO_COUNT: "cargoCount",
  TEMPLATE_FLAG: "templateFlag",
  TEMPLATE_NAME: "templateName",
  TIMEZONE: "timeZone",
  MESSAGE_FUNCTION: "messageFunction",
  AMENDMENT_CODE: "amendmentCode",
  TRUCKTITLE: "trucktitle",
  SEAL_TITLE: "sealTitle",
  EXCEPTION_CARGO: "exceptionCargo",
  TRUCK_ID: "truckId",
  CONVEYANCE_TYPE: "conveyanceType",
  CONVEYANCE_NUM: "conveyanceNum",
  LICENSE_NUM: "licenseNum",
  COUNTRY_CODE: "countryCode",
  STATUS: "status",
  REVIEW_STATUS: "reviewStatus",
  STATE: "state",
  EMAIL: "email",
  SAVE_TRUCKFLAG: "saveTruckFlag",
  FETCH_TRUCK: "fetchTruck",
  SAVE_TRUCKFLAG: "saveTruckFlag",
  FETCH_TRUCK: "fetchTruck",
  SAVE_TRUCKFLAG:"saveTruckFlag",
  FETCH_TRUCK:"fetchTruck",
  SEAL_EXCARGOFLAG:"sealExCargoFlag",
  SEAL_NO1: "sealNo1",
  SEAL_NO2: "sealNo2",
  SEAL_NO3: "sealNo3",
  SEAL_NO4: "sealNo4",
  SEAL_NO5: "sealNo5",
  SEAL_NO6: "sealNo6",
  SEAL_NO7: "sealNo7",
  SEAL_NO8: "sealNo8",
  SEAL_NO9: "sealNo9",
  SEAL_NO10: "sealNo10",
  SEAL_NO11: "sealNo11",
  SEAL_NO12: "sealNo12",
  SEAL_NO13: "sealNo13",
  SEAL_NO14: "sealNo14",
  SEAL_NO15: "sealNo15",
  SEAL_NO16: "sealNo16",
  SEAL_NO17: "sealNo17",
  SEAL_NO18: "sealNo18",
  SEAL_NO19: "sealNo19",
  SEAL_NO20: "sealNo20",
  SEAL_NO_HIDE_TEXT: "sealNoHideText",
  SEAL_NO_SHOW_TEXT: "sealNoShowText",
  SEAL_NO_FOOTER_TEXT: "sealNoFooterText",
  EXEMPTION_CARGO_HIDE_TEXT: "exemptionCargoHideText",
  EXEMPTION_CARGO_SHOW_TEXT: "exemptionCargoShowText",
  EXEMPTION_CARGO_FOOTER_TEXT: "exemptionCargoFooterText",
  CANTAINER_HIDE_TEXT: "containerHideText",
  CANTAINER_SHOW_TEXT: "containerShowText",
  CANTAINER_FOOTER_TEXT: "containerFooterText",
  CREATIONDATETIME: "creationDateTime",
  SUBMITTED_DATE: "submittedDate",
  IIT: "iit",
  LVS: "lvs",
  POSTAL: "postal",
  FLYING_TRUCKS: "flyingTrucks",
  CANCEL_BUTTON: "cancelButton",
  SUBMIT_BUTTON: "submitButton",
  CREATE_BUTTON: "createButton",
  SAVE_BUTTON: "saveButton",
  SAVE_AND_CONTINUE_BUTTON: "saveAndContinueButton",
  UPDATE_AND_CONTINUE_BUTTON: "updateAndContinueButton",
  SEND_BUTTON: "sendButton",
  EDIT_BUTTON: "editButton",
  VIEW_BUTTON: "viewButton",
  CLONE_BUTTON: "cloneButton",
  DELETE_BUTTON: "deleteButton",
  UPDATE_BUTTON: "updateButton",
  DISCARD_BUTTON: "discardButton",
  CREATE_ACE_MANIFEST_BUTTON: "createACEManifestButton",
  SKIP_BUTTON: "skipButton",
  SUBMIT_MANIFEST_BUTTON: "submitManifestButton",
  EDIT_MULTIPLE_RECORDS: "editMultipleRecords",
  EDIT_SENT_RECORDS: "editSentRecord",
  VIEW_MULTIPLE_RECORDS: "viewMultipleRecords",
  CLONE_MULTIPLE_RECORDS: "cloneMultipleRecords",
  DELETE_MULTIPLE_RECORDS: "deleteMultipleRecords",
  CANCEL_MULTIPLE_RECORDS:"cancelMultipleRecords",
  PRINT_COVERSHEET: "printCoverSheet",
  D4:"d4",
  EMAIL_COVERSHEET:"emailCoverSheet",
  EMAIL:"emailTitle",
  EMAIL_SUBJECT:"emailSubject",
  EMAIL_MESSAGE:"emailMessage",
  FAX_COVERSHEET:"faxCoverSheet",
  FAX_HELP_TEXT:"faxHelpText",
  FAX_REMARK:"faxRemark",
  // FAX:"faxCoverSheet",
  // FAX:"faxTitle",
  FAX_SUBJECT:"faxSubject",
  FAX_MESSAGE:"faxMessage",
  FAX: "fax",
  PRINT_MULTIPLE_RECORDS: "printMultipleRecords",
  SELECT_ACTION: "selectAction",
  SUBMIT_SENT_RECORD: "submitSentRecord",
  SUBMIT_SUCCESS_MSG: "submitSuccessMsg",
  SUBMIT_ERROR_MSG: "submitErrorMsg",
  SUBMIT_RECORD_DIALOG_CONTENT: "submitRecordDialogContent",
  SUBMIT_RECORD: "submitRecord",
  RESPONSE_TITLE: "response",
  ACTIVITY_LOGS: "activityLogs",
  CREATED_DATE_TIME: "createdDateTime",
  LOGIN_USER_ID: "loginUserId",
  FUNCTION_CODE: "functionCode",
  AUDIT_DESC: "auditDescription",
  CARGO: "cargo",
  CANT_EDIT_ST_RECORD: "cantEditST",
  CANT_SUBMIT_FROM_VIEW_PAGE: "cantSubmitFromViewPage",
  SEND_TO_CUSTOMS: "sendToCustoms",
  SEND_MANIFEST_WITH_CARGO: "sendManifestWithCargos",
  ATTACH_BUTTON: "attachButton",
  UPLOAD_BUTTON: "uploadButton",
  SUBMIT_ONEREC_ALERT: "submitOneRecordAlert",
  ERROR_MSG: "errorMessage",
  MESSAGE_FUNCTION_ADD: "messageFunctionAdd",
  MESSAGE_FUNCTION_MODIFY: "messageFunctionModify",
  MESSAGE_FUNCTION_DELETE: "messageFunctionDelete",
  MESSAGE_FUNCTION_CORRECTED: "messageFunctionCorrected",
  PRINT_A8A:"printA8A",
  PRINT_A49:"printA49",
  PRINT_MULTIPLE_RECORDS:"printMultipleRecords",
  NOTE_FLAG:"noteFlag",
  NOTE_CONTENT:"noteContent",
  CCN: "ccn",
  TOTAL_NO_OF_CARGO: "totalNoOfCargo",
  QUICK_GLANCE_TITLE: "quickGlanceTitle",
  OKAY_BUTTON: "okayButton",
  DELETE_WARNING_MESSAGE: "deleteWarningMessage",
  OK_DELETE_BUTTON: "okDeleteButton",
  CANCEL_DELETE_BUTTON: "cancelDeleteButton",
  USE_TEMPLATE: "useTemplate",
  TRUCK_CONVEYANCE: "truckConveyance",
  MANDATORY_FIELDS: "mandatoryFields",
  LICENSE_PLATE: "licensePlate",
  DRIVER_CREW_PASSENGER: "driverCrewPassenger",
  COUNTRY_REGISTRATION: "countryRegistration",
  PROVINCE_STATE_REGION_REGISTRATION: "provinceStateRegionRegistration",
  CONVEYANCE_TEMPLATE_TITLE: "conveyanceTemplateTitle",
  EMAIL_COVERSHEET_SUCCESS: "emailCoversheetSuccess",
  EMAIL_COVERSHEET_ERROR: "emailCoversheetError",
  FAX_COVERSHEET_SUCCESS: "faxCoversheetSuccess",
  FAX_COVERSHEET_ERROR: "faxCoversheetError",  
  NOTE: "note",
  RECORD_ADD_SUCCESS: "recordAddSuccess",
  ADD_DISCARD_CONFIRM_MSG: "addDiscardConfirmMsg",
  ADD_DISCARD_PROCEED_MSG: "addDiscardProceedMsg",
  ADD_DISCARD_CANCEL_MSG: "addDiscardCancelMsg",
  DISCARD_TITLE: "discardTitle",
  PORT_CODE_CHANGED_CONFIRM_MSG: "portCodeChangedConfirmMsg",
  CCN_HOUSEBILL_OVERLIMIT_MSG: "ccnHousebillOverLimitMsg",
  EMPTY_TRIP_CONFIRM_MSG: "emptyTripConfirmMsg",
  WITH_FAST_CARD: "withFastCard",
  WITH_TRAVEL_DOCUMENT: "withTravelDocument",
  NOTE_CLEAR_SUCCESS_MSG: "noteClearSuccessMsg",
  NOTE_CONTENT: "noteContent",
  NOTE_UPDATE_SUCCESS_MSG: "noteUpdateSuccessMsg",
  NOTE_SAVE_ERROR_MSG: "noteSaveErrorMsg",
  NOTE_LOG_SAVE_ERROR_MSG: "noteLogSaveErrorMsg",
  NOTE_CLEAR_ERROR_MSG: "noteClearErrorMsg",
  MAX_300_CHAR: "max300Char",
  NOTE_FOR_MANIFEST: "noteForManifest",
  INVALID_CHAR_FOUND: "invalidCharFound",
  REMINDER_NOTE: "reminderNote",
  RESET_NOTE: "resetNote",
  CREATED_DATE_EST: "createdDateEst",
  USERNAME: "username",
  NOTE_LABEL: "noteLabel",
  ADD_NEW_LABEL: "addNewLabel",
  CLONE_LABEL: "cloneLabel",
  DELETE_LABEL: "deleteLabel",
  DELETE_ITEM_CONFIRM_MSG: "deleteItemConfirmMsg",
  VIEW_RESPONSE: "viewResponse",
  CARGO_STATUS: "cargoStatus",
  PORT_MISMATCH: "portMismatch",
  QUICK_GLANCE_AT_CARGO: "quickGlanceAtCargo",
  FOLLOW_UP_STATUS: "followUpStatus",
  LAST_MODIFIED_DATE: "lastModifiedDate",
  DRAFT_STATUS: "draftStatus",
  ACCEPTED_STATUS: "acceptedStatus",
  SENT_STATUS: "sentStatus",
  REJECTED_STATUS: "rejectedStatus",
  STATUS_NOTIFICATION_STATUS: "statusNotificationStatus",
  CANCELLATION_ACCEPTED_STATUS: "cancellationAcceptedStatus",
  CANCELLATION_REJECTED_STATUS: "cancellationRejectedStatus",
  MODIFICATION_REJECTED_STATUS: "modificationRejectedStatus",
  TRUCK_ARRIVED_STATUS: "truckArrivedStatus",
  GOODS_RELEASED_STATUS: "goodsReleasedStatus",
  PENDING_REVIEW: "pendingReview",
  REVIEW_IN_PROGRESS: "reviewInProgress",
  REVIEWED: "reviewed",  
  DELETE_SUCCEEDED: "deleteSucceeded",
  MANIFEST_CANCELLED_MSG: "manifestCancelledMsg",
  MANIFEST_CANCEL_SENT_MSG: "manifestCancelSentMsg",
  MANIFEST_DELETE_IN_PROGRESS_MSG: "manifestDeleteInProgressMsg",
  MANIFEST_DELETE_SUCCEED_MSG: "massDeleteSucceedMsg",
  MANIFEST_DELETE_ERROR_MSG: "massDeleteErrorMsg",
  CREATE_MANIFEST: "createManifest",
  MANIFEST_TEMPLATE: "manifestTemplate",
  EXPORT_MAX_100: "exportMax100",
  EXPORT_MANIFEST_IN_BACKGROUND: "exportManifestInBackground",
  ONLY_DRAFT_CAN_BE_DELETED: "onlyDraftCanBeDeleted",
  RESPONSE_LOG_TITLE: "responseLogTitle",
  SEARCH_IN_YOUR_ENTRY: "searchInYourEntry",
  CREW_TEMPLATE: "crewTemplate",
  SEARCH_FOR_ANY_KEYWORD: "searchForAnyKeyword",
  NO_OF_ITEM_LABEL: "noOfItemLabel",
  ITEM_PER_PAGE_LABEL: "itemPerPageLabel",
  ADD_SN_BUTTON: "addSNButton",
  CREATE_TRIP_STEP: "createTripStep",
  ADD_CARGOS_STEP: "addCargosStep",
  SET_STATUS_NOTIFICATION_STEP: "setStatusNotificationStep",
  VIEW_LOGS_AND_HISTORY_STEP: "viewLogsAndHistoryStep",  
  ADD_SN_LABEL: "addSNLabel",
  OR_CLONE_THE_PREV_ONE: "orCloneThePrevOne",
  SN_UPDATED_MSG: "snUpdatedMsg",
  OPTIONAL: "optional",
  GO_TO_SUBMIT: "goToSubmit",
  ID: "id",
  INSERT_AND_POPULATE: "insertAndPopulate",
  ROW_PER_PAGE: "rowPerPage",
  PersonDTO: {
    TITLE: "personDTO.title",
    CREW_ID: "personDTO.crewId",
    ROLE: "personDTO.role",
    SAVE_CREW_FLAG: "personDTO.saveCrewFlag",
    FETCH_CREW: "personDTO.fetchCrew",
    FAST_CARD: "personDTO.fastCard",
    FAST_CARD_NUM: "personDTO.fastCardNum",
    FIRST_NAME: "personDTO.firstName",
    MIDDLE_NAME: "personDTO.middleName",
    LAST_NAME: "personDTO.lastName",
    CITIZEN_SHIP: "personDTO.citizenShip",
    DATE_OF_BIRTH: "personDTO.dateOfBirth",
    PERSON_EMAIL: "personDTO.personEmail",
    CELL_NUM: "personDTO.cellNum"
  },
  PersonDocumentDTO: {
    TITLE: "personDocumentDTO.title",
    PERSON_DTO: "personDocumentDTO._personDTOId",
    DOCUMENT_TYPE: "personDocumentDTO.documentType",
    ISSUING_COUNTRY: "personDocumentDTO.issuingCountry",
    DOCUMENT_NUMBER: "personDocumentDTO.documentNumber",
    EXPIRY_DATE: "personDocumentDTO.expiryDate"
  },
  TrailerDTO: {
    TITLE: "trailerDTO.title",
    CONATINER_TITLE: "trailerDTO.containerTitle",
    EQUIPMENT_ID: "trailerDTO.equipmentId",
    CARGO_LOADED_IN: "trailerDTO.cargoLoadedIn",
    EQUIPMENT_NUMBER: "trailerDTO.equipmentNumber",
    LICENSE_PLATE_NUM: "trailerDTO.licensePlateNum",
    LICENSE_PLATE_NO: "trailerDTO.licensePlateNo",
    SAVE_TRAILER_FLAG: "trailerDTO.saveTrailerFlag",
    FETCH_EQUIPMENT: "trailerDTO.fetchTrailer",
    COUNTRY: "trailerDTO.countryCode",
    CONT_SEAL_EXCARGOFLAG:"trailerDTO.contSealExCargoFlag",
    STATE_CODE: "trailerDTO.stateCode",
    CONTAINER1: "trailerDTO.container1",
    CONTAINER2: "trailerDTO.container2",
    CONTAINER3: "trailerDTO.container3",
    CONTAINER4: "trailerDTO.container4",
    CONTAINER5: "trailerDTO.container5",
    SEAL_NO1: "trailerDTO.sealNo1",
    SEAL_NO2: "trailerDTO.sealNo2",
    SEAL_NO3: "trailerDTO.sealNo3",
    SEAL_NO4: "trailerDTO.sealNo4",
    SEAL_NO5: "trailerDTO.sealNo5",
    SEAL_NO6: "trailerDTO.sealNo6",
    SEAL_NO7: "trailerDTO.sealNo7",
    SEAL_NO8: "trailerDTO.sealNo8",
    SEAL_NO9: "trailerDTO.sealNo9",
    SEAL_NO10: "trailerDTO.sealNo10",
    SEAL_NO11: "trailerDTO.sealNo11",
    SEAL_NO12: "trailerDTO.sealNo12",
    SEAL_NO13: "trailerDTO.sealNo13",
    SEAL_NO14: "trailerDTO.sealNo14",
    SEAL_NO15: "trailerDTO.sealNo15",
    SEAL_NO16: "trailerDTO.sealNo16",
    SEAL_NO17: "trailerDTO.sealNo17",
    SEAL_NO18: "trailerDTO.sealNo18",
    SEAL_NO19: "trailerDTO.sealNo19",
    SEAL_NO20: "trailerDTO.sealNo20",
    IIT: "trailerDTO.iit",
    LVS: "trailerDTO.lvs",
    POSTAL: "trailerDTO.postal",
    FLYING_TRUCKS: "trailerDTO.flyingTrucks",
    ACTION: "trailerDTO.action",
    NO_RECORD_TO_DISPLAY: "trailerDTO.noRecordsToDisplay",
    ADD_EQUIPMENT: "trailerDTO.addEquipment"
  },
  StatusNotification: {
    TITLE: "statusNotification.title",
    NAME: "statusNotification.name",
    SN_TYPE: "statusNotification.snType",
    SHIPMENT_CONTROL_NUM: "statusNotification.shipmentControlNum",
    EMAIL: "statusNotification.email",
    MOBILE_NUM: "statusNotification.mobileNum",
    FAX_NUM: "statusNotification.faxNum"
  },
  Validations: {
    CARRIER_CODE_LENGTH: "validations.carrierCodeLength",
    CARRIER_CODE_REGX: "validations.carrierCodeRegx",
    TRIP_NUM_LENGTH: "validations.tripNumLength",
    TRIP_NUM_PREFIX: "validations.tripNumPrefix",
    EXP_ARRIVAL_DATE: "validations.expArrivalDateValidation",
    EXP_ARRIVAL_DATE_REGX: "validations.expArrivalDateTimeRegx",
    EXPIRY_DATE: "validations.expiryDateValidation",
    ALPHA_NUMERIC_REGX: "validations.alphaNumericRegx",
    ALPHA_NUMERIC_SPACE_REGX: "validations.alphaNumericSpaceRegx",
    NUMERIC_REGX: "validations.numericRegx",
    EMAIL_MAX_LENGTH: "validations.emailMaxLength",
    EMAIL_VALID: "validations.emailValid",
    MSGFUN_FOR_AC: "validations.msgfunForAC",
    MSGFUN_FOR_DR: "validations.msgfunForDR",
    MSGFUN_FOR_CL: "validations.msgfunForCL",
    MSGFUN_FOR_MR: "validations.msgfunForMR",
    MSGFUN_FOR_RJ: "validations.msgfunForRJ",
    MSGFUN_FOR_CR: "validations.msgfunForCR",
    MSGFUN_FOR_NEW_REC: "validations.msgfunForNewRec",
    ENTER_VALID_INPUT: "validations.enterValidInput",
    NON_FAST_CARD_USER: "validations.nonFastcardUser",
    ALPHA_NUMERIC_WITH_SPLCHARS: "validations.aplhaNumericWithSplChars",
    ALPHA_NUMERIC_WITH_MORE_SPLCHARS: "validations.alphaNumericWithMoreSplChars",
    MAX_LENGTH_255: "validations.maxLength255",
    MAX_LENGTH_15: "validations.maxLength15",
    MAX_LENGTH_25: "validations.maxLength25",
    MAX_LENGTH_254: "validations.maxLength254",
    FAX_VALID:"validations.faxValid",
    MAX_LENGTH:"validations.maxLength11",
    NUM_ONLY_NO_SPACE: "validations.numOnlyNoSpace",
    MIN_LENGTH_11: "validations.minLength11"
  },
  TRIP_SECTION_HELPER: "tripSectionHelper",
  TRUCK_TRAILER_SECTION_HELPER: "truckTrailerSectionHelper",
  CREW_SECTION_HELPER: "crewSectionHelper",
}

export default ManifestKeys
